<template>
  <vz-button-dropdown
    ref="button"
    icon-name="link"
    :items="items"
    right
    @select="linkSelect"
  >
    <slot>Ссылка</slot>
  </vz-button-dropdown>
</template>

<script setup lang="ts">
import {storeToRefs} from 'pinia';
import {useOrderStore} from '~/stores/order';
import {orderSaveCalc} from '@/api/order';
import {pricePayload} from '~/common/objects';
import {useClipboard} from '@vueuse/core';
import VzButtonDropdown from '~/components/ui-kit/vz-button-dropdown.vue';

const { orderForm } = storeToRefs(useOrderStore())
const { $showToast, $showToastText,$showDialog } = useNuxtApp()

const items = [
  { title: 'Скопировать', value: 'copy' },
  { title: 'Отправить по E-mail', value: 'email' }
]

const button = ref(null as typeof VzButtonDropdown)

async function linkSelect(value: string): Promise<void> {
  if (value === 'copy') {
    const { hash, origin } = await orderSaveCalc(pricePayload(orderForm.value))
    const { href } = window.location
    const uri = href.split('/')
    let url = `/order/create/?calculation=${hash}`

    if (uri.includes('personal')) {
      url = `/${uri[3]}/order/create/?calculation=${hash}`
    }

    const link = `${origin}${url}`

    useClipboard().copy(link)
      .then(() => {
        if (button.value) {
          $showToastText({
            el: button.value.$el,
            text: 'Скопирован',
            left: '0%',
            top: '-36px'
          })
        }
      })
      .catch((err) => {
        $showToast({
          title: 'Расчет стоимости заказа',
          text: 'Проблема с копированием: ' + err,
          variant: 'error'
        })
      })
  }
  if (value === 'email') {
    $showDialog({name: 'vz-email-modal'})
  }
}
</script>
